import {
    useState,
    useEffect,
    useContext } from 'react';

import { useLocation } from 'react-router-dom';

import styles from './candidateInfo.module.scss';
import notificationStyles from '../../components/notification/notification.module.scss';

import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import CandidateForms from './candidateForms';
import CandidateResume from './candidateResume';
import ConfirmationMessage from './confirmationMessage';
import Notification from '../../components/notification/notification';
import admirationIcon from '../../../assets/icons/admiration_white.svg';

import { AppContext } from '../../../router/approuter';
import { validateToken } from '../../api/userClient';
import { getCatalog } from '../../api/catalogClient';
import { appConfig } from '../../config/runtimeConfig';

export const handlingError = (error, displayNotification) => {
    const { status, data } = error.response;
    if( error.code === 'ERR_NETWORK' ) {
        displayNotification(null, false, false, true);
    } else if ( status === 503 ) {
        const responseParsed = new DOMParser().parseFromString(data, 'text/html');
        if ( responseParsed && responseParsed.getElementsByTagName('h1') ) {
            displayNotification(responseParsed.getElementsByTagName('h1')[0].innerText, true, 3000, false);
        }
    }
}

const CandidateInfo = () => {
    const appContext = useContext(AppContext);
    let pageLocation = useLocation();

    const [catSeniority, setCatSeniority] = useState([]);
    const [catSector, setCatSector] = useState([]);
    const [catCountries, setCatCountries] = useState([]);
    const [catCurrencies, setCatCurrencies] = useState([]);
    const [personalInfo, setPersonalInfo] = useState({})
    const [stepIndex, setStepIndex] = useState(0);
    const [notificationData, setNotificationData] = useState({
        notificationStyle: notificationStyles.notification_wrapper
    });
    const [resumeViewFlag, setResumeViewFlag] = useState(!localStorage.getItem("userNew"))
    const notification = <Notification data={ notificationData } />;

    const cookieDomain = appConfig.cookieDomain;
    const cookieName = appConfig.cookieName;

    const loadSeniorities = () => {
        getCatalog(1000030003, 0 ,200, '&sort=id&direction=ASC', appContext.userData.token).then(({status, data}) => {
            if( status === 202 && data && data.code === 202 && data.result && data.result.content && Array.isArray(data.result.content) ) {
                let catSeniority = [];
                let content = data.result.content;
                content.map(l => catSeniority.push({ id: l.catalogItemId, description: l.description, optionName: l.valueItem }))
                setCatSeniority(catSeniority);
            }
        }).catch((error) => {
            //console.log(error);
            handlingError(error, displayNotification);
        })
    }

    const loadCatSector = () => {
        getCatalog(1000020052, 0 ,100, '', appContext.userData.token).then(({status, data}) => {
            if( status === 202 && data && data.code === 202 && data.result && data.result.content && Array.isArray(data.result.content) ) {
                const sectorTmp = [];
                data.result.content.forEach(s => sectorTmp.push({ id: s.catalogItemId, optionName: s.valueItem }))
                setCatSector(sectorTmp);
            }
        }).catch(error => {
            handlingError(error, displayNotification);
        });
    }

    const loadCountries = () => {
        getCatalog(1000020016, 0 ,200, '&sort=id&direction=ASC', appContext.userData.token).then(({status, data}) => {
            if( status === 202 && data && data.code === 202 && data.result && data.result.content && Array.isArray(data.result.content) ) {
                let catCountries = [];
                let content = data.result.content;
                content.map(l => catCountries.push({ id: l.catalogItemId, optionName: l.valueItem, description: l.description }))
                setCatCountries(catCountries);
            }
        }).catch((error) => {
            // console.log(error);
            handlingError(error, displayNotification);
        })
    }

    const loadCurrencies = () => {
        getCatalog(1000020055, 0 ,200, '&sort=id&direction=ASC', appContext.userData.token).then(({status, data}) => {
            if( status === 202 && data && data.code === 202 && data.result && data.result.content && Array.isArray(data.result.content) ) {
                let catCurrencies = [];
                let content = data.result.content;
                content.map(l => catCurrencies.push({ id: l.catalogItemId, optionName: l.description, description: l.valueItem }))
                setCatCurrencies(catCurrencies);
            }
        }).catch((error) => {
            // console.log(error);
            handlingError(error, displayNotification);
        })
    }

    const displayNotification = (message, isWarn, timer, isErrorConection) => {
        window.scrollTo(0, 0);
        const style = isErrorConection ? notificationStyles.notification_wrapper_error : (isWarn ? notificationStyles.notification_wrapper_warning : notificationStyles.notification_wrapper);
        const icon = isWarn ? admirationIcon : undefined;
        setNotificationData({
            notificationStyle: ( `${ style } ${notificationStyles.active}` ),
            message: message,
            icon: icon,
            isDisplay: true,
            isErrorConection: isErrorConection
        });

        if( !isErrorConection && timer > 0 ) {
            setTimeout(() => {
                setNotificationData({
                    notificationStyle: style,
                    message: message,
                    icon: icon,
                    isDisplay: false
                })
            }, timer);
        }
    }

    const checkSession = () => {
        appContext.showLoading(true, 'Cargando', styles.no_scroll);
        validateToken(appContext.userData.token).then((response) => {
            appContext.showLoading(false, '', styles.no_scroll);
            if( response.status === 200 && response.data.code === 200 ) {
                setStepIndex(8);
            } else {
                appContext.setUserData(null);
                localStorage.removeItem('userNew');
                localStorage.removeItem('userInfo');
                return appContext.navigate("/login");
            }
        }).catch((error) => {
            appContext.showLoading(false, '', styles.no_scroll);
            if( error.code === 'ERR_NETWORK' ) {
                displayNotification(`${error.message}: Imposible validar sesión, el servicio cuenta con bloqueo CORs`, true, 5000, false);
            } else if( error.response.status === 400 && error.response.data.code === 30005 && error.response.data.msg === 'Token inválido.' ) {
                appContext.setUserData(null);
                localStorage.removeItem('userNew');
                localStorage.removeItem('userInfo');
                return appContext.navigate("/login");
            }
        })
    }

    const candidateForm = <CandidateForms 
        stepIndex={stepIndex}
        setStepIndex={setStepIndex}
        displayNotification={ displayNotification }
        resumeViewFlag={ resumeViewFlag }
        personalInfo={ personalInfo }
        setPersonalInfo={ setPersonalInfo }
        appContext={ appContext }
        catSeniority={ catSeniority }
        catSector={ catSector }
        catCountries={ catCountries }
        catCurrencies={ catCurrencies }
    />;

    useEffect(() => {
        // regresando a login si no ha iniciado sesión
        if (!appContext.userData) {
            return appContext.navigate("/login");
        }
        loadSeniorities();
        loadCatSector();
        loadCountries();
        loadCurrencies();
        if(resumeViewFlag) {
            checkSession();
        } else {
            setPersonalInfo({
                firstName: appContext.userData.userProfile.firstName,
                lastName: appContext.userData.userProfile.lastName,
                email: appContext.userData.userProfile.email
            })
            const currentDate = new Date();
            currentDate.setFullYear(currentDate.getFullYear() + 1);

            const sessionCookie = `${cookieName}=${appContext.userData.userProfile.firstName}|${appContext.userData.userProfile.lastName}|${appContext.userData.userProfile.id}|0|${appContext.userData.token};expires=${currentDate};domain=${cookieDomain};path=/;`;
            // console.log('CandidateInfo - Cookie session', sessionCookie);
            document.cookie = sessionCookie;
        }
    }, [])

    const renderLoading = () => appContext.loadingData.flag && (
        <div className={ styles.loading_container }>
            <div className={ styles.spinner_container }>
                <div className={ styles.spinner }></div>
                <p>{ appContext.loadingData.loadingLabel }</p>
            </div>
        </div>
    )

    return(
        <div className={ `${styles.modal_wrapper} ${appContext.modalFlag ? styles.modal_active : ''}` }>
            { renderLoading() }
            { appContext.modalFlag && appContext.modal }
            <Header
                userData={ appContext.userData }
                navigate={ appContext.navigate }
                setUserData={ appContext.setUserData }
                modalFlag={ appContext.modalFlag }
                setModalFlag={ appContext.setModalFlag }
                setModalContent={ appContext.setModalContent }
                stepIndex={ stepIndex }/>
            <div
                className={ appContext.isDesktopOrLaptop ? styles.candidate_info : styles.candidate_info_mobile }
                style={{ background: stepIndex === 9 ? 'linear-gradient(131.35deg, rgba(176, 98, 253, 0.05) 2.12%, rgba(110, 172, 231, 0.17) 99.1%)' : 'white'  }}
            >
                { notification }
                <div className={ `${styles.wrapper} ${stepIndex === 8 ? styles.wrapper_slim : undefined}` }>
                    {
                        stepIndex <= 7 && candidateForm
                    }
                    {
                        stepIndex === 8 && (
                            <CandidateResume
                                setStepIndex={setStepIndex}
                                setResumeViewFlag={ setResumeViewFlag }
                                personalInfo={ personalInfo }
                                setPersonalInfo={ setPersonalInfo }
                                displayNotification={ displayNotification }
                                catCountries={ catCountries }
                                catCurrencies={ catCurrencies }
                            />)
                    }
                    {
                        stepIndex === 9 && (
                            <ConfirmationMessage
                                personalInfo={ personalInfo }
                                setStepIndex={setStepIndex} />
                        )
                    }
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default CandidateInfo
